// ABOUTME: Displays products where forecast generation failed.
// ABOUTME: Collapsible accordion showing error messages, positioned above ignored tasks.

import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Box,
} from '@mui/material';
import {
  ExpandMore as ExpandMoreIcon,
  ErrorOutline as ErrorIcon,
} from '@mui/icons-material';

function FailedProductsSection({ products, expanded, onExpandChange, onProductSelect }) {
  const { t } = useTranslation();

  if (!products || products.length === 0) {
    return null;
  }

  const getErrorMessage = (errorCode) => {
    switch (errorCode) {
      case 'no_sales_data':
        return t('dashboard.schedule.failed.noSalesData');
      case 'no_training_data':
        return t('dashboard.schedule.failed.noTrainingData');
      default:
        return t('dashboard.schedule.failed.unknownError');
    }
  };

  return (
    <Accordion
      expanded={expanded}
      onChange={(e, isExpanded) => onExpandChange(isExpanded)}
      sx={{ opacity: 0.7 }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Box display="flex" alignItems="center" gap={1}>
          <ErrorIcon color="warning" fontSize="small" />
          <Typography color="text.secondary">
            {t('dashboard.schedule.failed.title')} ({products.length})
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <List dense>
          {products.map((product, index, array) => (
            <React.Fragment key={`failed-${product.product_id}-${index}`}>
              <ListItem
                onClick={() => onProductSelect && onProductSelect(product.product_id)}
                sx={{ cursor: onProductSelect ? 'pointer' : 'default' }}
              >
                <ListItemIcon>
                  <ErrorIcon color="warning" fontSize="small" />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Typography variant="subtitle2" color="text.secondary">
                      {product.product_name}
                      <Typography
                        component="span"
                        variant="caption"
                        color="text.secondary"
                        sx={{ ml: 1, fontWeight: 'normal' }}
                      >
                        ({product.product_id})
                      </Typography>
                    </Typography>
                  }
                  secondary={
                    <Typography variant="caption" color="warning.main">
                      {getErrorMessage(product.error_code)}
                    </Typography>
                  }
                />
              </ListItem>
              {index < array.length - 1 && <Divider />}
            </React.Fragment>
          ))}
        </List>
      </AccordionDetails>
    </Accordion>
  );
}

export default FailedProductsSection;